/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CustomerOnboardingResponseDTO,
  GroupCustomerOnboardingDTO,
  IndividualCustomerOnboardingDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const createIndividualCustomer = (
    individualCustomerOnboardingDTO: IndividualCustomerOnboardingDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerOnboardingResponseDTO>(
      {url: `/api/customer-onboarding/individual`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: individualCustomerOnboardingDTO, signal
    },
      options);
    }
  


export const getCreateIndividualCustomerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createIndividualCustomer>>, TError,{data: IndividualCustomerOnboardingDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createIndividualCustomer>>, TError,{data: IndividualCustomerOnboardingDTO}, TContext> => {

const mutationKey = ['createIndividualCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createIndividualCustomer>>, {data: IndividualCustomerOnboardingDTO}> = (props) => {
          const {data} = props ?? {};

          return  createIndividualCustomer(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateIndividualCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof createIndividualCustomer>>>
    export type CreateIndividualCustomerMutationBody = IndividualCustomerOnboardingDTO
    export type CreateIndividualCustomerMutationError = unknown

    export const useCreateIndividualCustomer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createIndividualCustomer>>, TError,{data: IndividualCustomerOnboardingDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createIndividualCustomer>>,
        TError,
        {data: IndividualCustomerOnboardingDTO},
        TContext
      > => {

      const mutationOptions = getCreateIndividualCustomerMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const createGroupCustomer = (
    groupCustomerOnboardingDTO: GroupCustomerOnboardingDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerOnboardingResponseDTO>(
      {url: `/api/customer-onboarding/group`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: groupCustomerOnboardingDTO, signal
    },
      options);
    }
  


export const getCreateGroupCustomerMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroupCustomer>>, TError,{data: GroupCustomerOnboardingDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createGroupCustomer>>, TError,{data: GroupCustomerOnboardingDTO}, TContext> => {

const mutationKey = ['createGroupCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGroupCustomer>>, {data: GroupCustomerOnboardingDTO}> = (props) => {
          const {data} = props ?? {};

          return  createGroupCustomer(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateGroupCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof createGroupCustomer>>>
    export type CreateGroupCustomerMutationBody = GroupCustomerOnboardingDTO
    export type CreateGroupCustomerMutationError = unknown

    export const useCreateGroupCustomer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGroupCustomer>>, TError,{data: GroupCustomerOnboardingDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createGroupCustomer>>,
        TError,
        {data: GroupCustomerOnboardingDTO},
        TContext
      > => {

      const mutationOptions = getCreateGroupCustomerMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const health = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/customer-onboarding/health`, method: 'GET', signal
    },
      options);
    }
  

export const getHealthQueryKey = () => {
    return [`/api/customer-onboarding/health`] as const;
    }

    
export const getHealthQueryOptions = <TData = Awaited<ReturnType<typeof health>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof health>>> = ({ signal }) => health(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type HealthQueryResult = NonNullable<Awaited<ReturnType<typeof health>>>
export type HealthQueryError = unknown


export function useHealth<TData = Awaited<ReturnType<typeof health>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof health>>,
          TError,
          Awaited<ReturnType<typeof health>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHealth<TData = Awaited<ReturnType<typeof health>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof health>>,
          TError,
          Awaited<ReturnType<typeof health>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useHealth<TData = Awaited<ReturnType<typeof health>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useHealth<TData = Awaited<ReturnType<typeof health>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof health>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getHealthQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



